import { Modal } from '@/components/widgets/modal';
import { modalContainerStyle } from './modal-container.style';

type TutorialModalProps = {
	isOpen: boolean;
	closeModal: () => void;
	title: string;
	children: React.ReactNode;
}

export const ModalContainer = ({
	isOpen,
	closeModal,
	title,
	children
}: TutorialModalProps) => {

	return (
		<Modal
			isOpen={isOpen}
			closeModal={closeModal}
			showHeader={true}
			title={title}
			className={modalContainerStyle.modal}
		>
			<div className={modalContainerStyle.modalWapper}>
				{children}
			</div>
		</Modal>
	);
}

